<template>
    <v-container>

        <v-breadcrumbs :items="['오류']">
            <template v-slot:prepend>
                <v-icon size="small" icon="mdi-alert-circle-outline"></v-icon>
            </template>
        </v-breadcrumbs>
        
        <v-row>
            <v-col class="content-box" style="font-size:22px">
                요청 <span style="color:blue">권한</span>이 없습니다.
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>          

</script>